<template lang='pug'>
  .terms-container
    .modal.fade#billboard-terms(aria-hidden='true' role='dialog' tabindex='1')
      .modal-dialog(role='document')
        .modal-content
          .modal-header
            .modal-title.terms-title(v-html='title || $t("common.termsAndConditions")')
            button.close(type='button' data-dismiss='modal' aria-label='Close')
          .modal-seperator
          .modal-body
            img.terms-image(v-if='image' v-lazy='image')
            p.terms-description(v-html='description')
</template>

<script>
export default {
  props: [
    'title',
    'description',
    'image'
  ]
}
</script>

<style scoped lang='scss'>
  .terms-container {
    position: absolute;
    left: 0;
    bottom: 6px;

    @include media-breakpoint-up(sm) {
      bottom: 0;
    }

    .terms-title {
      @include font-weight-bold;
      font-size: 13px;
      text-align: left;
    }

    .terms-description {
      text-align: left;
      line-height: 16px;
    }

    .terms-image {
      max-height: 200px;
      width: auto !important;
      margin-bottom: 15px;
    }

    .terms-title {
      @include font-weight-bold;
      font-size: 18px;
      width: 90%;
      text-align: left;
    }

    .modal-seperator {
      border-top: 1px solid $grey;
      margin: 5px 15px 20px;
    }
  }
</style>
